<div class="relative">
  <button class="bg-gray-6 rounded-full p-1 flex items-center shadow-fution-small hover:bg-light-blue hover:opacity-70 hover:text-lighter focus:bg-light-blue focus:text-lighter" (click)="toggleMenu()">
    <span class="material-symbols-rounded leading-none">help</span>
  </button>

  <div
    class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-b-lg bg-white focus:outline-none p-2"
    [hidden]="!menuOpen"
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="menu-button"
    tabindex="-1"
  >
    <div class="flex flex-col gap-4">
      <!-- <a
        href="./assets/pdf/Manual_de_usuario_VenV.pdf"
        download="Manual_de_usuario_VenV.pdf"
        class="text-gray-2 text-smPlus font-light cursor-pointer flex items-center gap-2"
        role="menuitem"
        tabindex="-1"
        ><span class="material-symbols-rounded text-blue-pressed">
          download
          </span> 
          Manual de usuario
      </a> -->
      <a
        (click)="openModalTour()"
        target="_blank"
        class="text-gray-2 text-smPlus font-light cursor-pointer"
        role="menuitem"
        tabindex="-1"
        >Te ayudamos paso a paso</a
      >
      <a
        href="https://www.avla.com/cl/"
        target="_blank"
        class="text-gray-2 text-smPlus font-light cursor-pointer"
        role="menuitem"
        tabindex="-1"
        >Somos AVLA</a
      >
    </div>
  </div>
</div>
